import { Flex, Icon, Text } from '@Common/Components'
const gray = 'rgba(90, 90, 90, 0.85)'

const PhoneMail = ({ icon, text }) => (
  <>
    <Flex fw row wrap style={{ width: '120%' }}>
      <Icon name={icon} style={{ backgroundColor: 'white', borderRadius: 50, width: 50, height: 50, marginBottom: 10, marginRight: 5 }} />
      <Text value={text} style={{ marginBottom: 10, marginLeft: 5 }} color={gray} />
    </Flex>
    <hr style={{ width: '80%', borderColor: 'white', margin: 20 }} />
  </>
)

const days = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica']
const OpeningTime = ({ openSchedule }) =>
  openSchedule?.map((day, index) => (
    <Flex key={index} as js fw row style={{ padding: 5 }}><Text color={gray} value={days[index] + ':'} style={{ width: '40%', marginLeft: -20, paddingLeft: '6%' }} />
      <Flex fw wrap row style={{ marginRight: -40 }}>
        {
          day.map((hours, index) =>
            <Flex row key={index}><Text color={gray} value={hours.from + ' - '} /><Text color={gray} value={hours.to} style={{ marginRight: 5 }} /></Flex>
          )
        }
      </Flex>
    </Flex>))

export const Agency = ({ agency }) => {
  const { openSchedule, logo, name, email, telephone, note } = agency

  return (
    <Flex style={{ margin: 10 }}>
      <img src={`https://s3.eu-central-1.amazonaws.com/siap.apptour.uploads/${logo}`} style={{ width: '50%', marginBottom: 20 }} alt='logo' />
      <Text center bold size={24} value={name} />
      <Text color={gray} center value={note} style={{ marginTop: 10 }} />
      <hr style={{ width: '80%', borderColor: 'white', margin: 30 }} />
      <PhoneMail icon='mail' text={email} />
      <PhoneMail icon='phone' text={telephone} />
      <Text value='ORARI APERTURA AL PUBBLICO' center bold size={18} />
      <OpeningTime openSchedule={openSchedule} />
    </Flex>
  )
}
